
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/panels/focusPanels/siteAccessPanel/siteAccessPanel.scss.css.virtualfile';
        module.exports = {"text":"_text_1gaok_1","thumbnails":"_thumbnails_1gaok_5","divider":"_divider_1gaok_9","passwordControl":"_passwordControl_1gaok_12"};